import ManagePage from "./ManagePage";

export default ManagePage;
